'use client'

import type { ReactNode } from 'react'
import { SharedSurfaceProvider, type SharedSkin, type SharedSurface } from '@/deskUiSkeletons/Shared/SharedSurfaceContext'
import { MsgDeskLoading } from '../MsgDeskLoading'

const pooSharedSkin: SharedSkin = {
  navItem: 'group relative flex h-9 cursor-pointer items-center rounded-md px-3 text-xs font-medium text-[#58635f] hover:bg-[#ece9e1] hover:text-[#16231f]',
  navItemSelected: 'bg-[#173f35] text-white',
  navLabel: 'flex items-center',
  navLoading: 'animate-pulse',
  moreLink: 'mt-2 inline-flex w-max cursor-pointer text-xs font-semibold text-[#245f51] hover:underline',
  testBadge: 'fixed right-2 top-16 z-[100000] rounded bg-red-600 px-2 py-1 text-[10px] font-bold text-white',
  testBadgeInfo: 'hidden',
  dialogBackdrop: 'hidden',
  dialogWindow: 'hidden',
  savingBackdrop: 'fixed inset-0 z-[100001] hidden bg-black/25',
  savingContent: 'fixed left-1/2 top-1/2 z-[100002] hidden -translate-x-1/2 -translate-y-1/2',
  msgBoxOverlay: 'fixed inset-0 z-[100003] hidden bg-white/70 text-center text-[#25302d]',
  msgBoxSpacer: 'h-[40%]',
  msgBox: 'inline-flex max-w-full flex-col overflow-hidden rounded-lg border border-[#d7d1c5] bg-white shadow-xl',
  msgBoxInfo: 'flex flex-col items-center p-4',
  msgBoxText: 'my-2',
  msgBoxPin: 'hidden',
  msgBoxCaptchaImg: 'block h-auto w-auto',
  msgBoxButtons: 'flex justify-center gap-2 border-t border-[#ded9cf] bg-[#f7f5f0] p-2',
  msgBoxClose: 'cursor-pointer px-3 py-1 text-[#245f51]',
  msgBoxHiddenCancel: 'hidden',
  qrOverlay: 'fixed inset-0 z-[100000] flex items-center justify-center bg-black/30 p-4',
  qrInline: 'my-2 mx-2 max-w-[560px]',
  qrRoot: 'w-[min(523px,calc(100vw-32px))]',
  qrForm: 'block min-h-[180px] rounded-lg bg-white p-3 text-[#25302d] shadow-xl',
  qrEditForm: 'w-full',
  qrTextarea: 'block h-[130px] w-full rounded-md border border-[#cfc8bc] bg-white p-2 text-sm',
  qrEmailLabel: 'block text-xs',
  qrCheckbox: 'mr-2',
  qrEmailLink: 'text-xs text-[#245f51]',
  qrEmailValue: 'underline',
  qrActions: 'flex justify-end gap-2',
  qrSaveButton: 'rounded-md bg-[#245f51] px-3 py-1.5 text-xs font-semibold text-white',
  qrShadowRight: 'hidden',
  qrShadowBottom: 'hidden',
  pinOverlay: 'fixed inset-0 z-[100004] flex items-center justify-center bg-white/70 p-5 text-xs text-[#25302d] backdrop-blur-sm',
  pinBox: 'flex w-[280px] max-w-full flex-col rounded-lg border border-[#d7d1c5] bg-white shadow-2xl',
  pinMessage: 'px-4 pb-2 pt-4 text-center font-semibold',
  pinInput: 'mx-4 mb-3 rounded-md border border-[#cfc8bc] bg-white p-2 text-sm outline-none focus:border-[#245f51]',
  pinActions: 'flex justify-end gap-2 border-t border-[#ded9cf] bg-[#f7f5f0] p-3',
  pinButton: 'rounded-md px-3 py-1.5 text-xs font-medium text-[#58635f] hover:bg-[#e9e5dc]',
  pinButtonPrimary: 'rounded-md bg-[#245f51] px-3 py-1.5 text-xs font-semibold text-white hover:bg-[#173f35]',
}

const pooSharedSurface: SharedSurface = { Loading: MsgDeskLoading, skin: pooSharedSkin }

export function PooSharedSurfaceProvider({ children }: { children: ReactNode }) {
  return <SharedSurfaceProvider value={pooSharedSurface}>{children}</SharedSurfaceProvider>
}
